import PopupActions from '../../redux/actions/popupActions';
import imageActions from '../../redux/actions/imageActions';
import CanvasActions from '../../redux/actions/canvasActions';
import ValidatorActions from '../../redux/actions/validatorActions';
import previewActions from '../../redux/actions/previewActions';
import AnalyticsSender from '../../helpers/analyticsSender';
import { useDispatch } from 'react-redux';

const Clear = (props: {
  content: {
    title: string;
    description: string;
    question: string;
    actionButton: string;
  };
}) => {
	const { clearPopup } = PopupActions();
	const { imageClear } = imageActions();
	const { canvasClear } = CanvasActions();
	const { clearValidationInfo } = ValidatorActions();

	const { previewClear } = previewActions();
	const analyticsSender = new AnalyticsSender();
  
	const dispatch = useDispatch();

	const clearAllStates = () => {
		imageClear();
		canvasClear();
		previewClear();
		clearValidationInfo();
		clearPopup();
		dispatch({ type: 'SERVICE_SET_CROP_DIMENSIONS', cropDimensions: { width: 0, height: 0 } });
		dispatch({ type: 'SERVICE_SET_CROP_POSITION', cropPosition: { x: undefined, y: undefined } });
		dispatch({ type: 'SERVICE_SET_CROP_DIMENSIONS', cropDimensions: { width: 0, height: 0 } });
		dispatch({ type: 'SET_ERROR', error: null });
		dispatch({ type: 'CANVAS_SET_VALIDATION', cropValidation: {}});
		analyticsSender.sendRemoveImage();
	};

	return (
		<>
			<h3 className="popup__remove-title">{props.content.title}</h3>
			<button
				className="popup__remove-close"
				onClick={() => {
					clearPopup();
				}}
			></button>

			{props.content.description ? (
				<p className="popup__remove-content">{props.content.description}</p>
			) : (
				<></>
			)}

			<p className="popup__remove-question">{props.content.question}</p>

			<button className="popup__remove-action" onClick={clearAllStates}>
				{props.content.actionButton}
			</button>
		</>
	);
};

export default Clear;
